export class SamvadaBus extends EventTarget {
    rememberKeys = new Set();
    static STORAGE_PREFIX = 'thob:bus:';
    /** Emit an event. Synchronous; persisted if the event was flagged via `rememberFor`. */
    emit(type, payload, source) {
        const detail = { payload, _ts: Date.now(), _source: source };
        this.dispatchEvent(new CustomEvent(type, { detail }));
        if (this.rememberKeys.has(type) && SamvadaBus.hasStorage()) {
            try {
                sessionStorage.setItem(SamvadaBus.STORAGE_PREFIX + type, JSON.stringify(detail));
            }
            catch {
                /* quota / disabled — best effort */
            }
        }
    }
    /** Subscribe. Returns an unsubscribe function. */
    on(type, handler) {
        const listener = (e) => {
            const detail = e.detail;
            handler(detail.payload, { ts: detail._ts, source: detail._source });
        };
        this.addEventListener(type, listener);
        return () => this.removeEventListener(type, listener);
    }
    /** Mark an event type as durable across navigations (persisted on emit). */
    rememberFor(type) {
        this.rememberKeys.add(type);
    }
    /** Recall the last persisted payload for an event, or null. */
    recall(type) {
        if (!SamvadaBus.hasStorage())
            return null;
        try {
            const raw = sessionStorage.getItem(SamvadaBus.STORAGE_PREFIX + type);
            if (!raw)
                return null;
            const parsed = JSON.parse(raw);
            return parsed.payload;
        }
        catch {
            return null;
        }
    }
    static hasStorage() {
        return typeof sessionStorage !== 'undefined';
    }
}
/** Get the singleton bus, bootstrapping it if needed (browser only). */
export function getBus() {
    if (typeof window === 'undefined')
        return new SamvadaBus();
    window.__thobBus ??= new SamvadaBus();
    return window.__thobBus;
}
// Idempotent auto-bootstrap when loaded as a theme asset.
if (typeof window !== 'undefined') {
    window.__thobBus ??= new SamvadaBus();
}
//# sourceMappingURL=samvada-bus.js.map